<template>
  <div id="app">
    <meta name="referrer" content="no-referrer">
    <keep-alive>
      <router-view v-if="isRouterAlive" />
    </keep-alive>
  </div>
</template>

<script>
  import request from "./utils/request";
  export default {
    name: 'App',
    provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        isRouterAlive: true //控制视图是否显示的变量
      }
    },
    created() {
      this.getBtn()
    },
    methods: {
      reload() {
        this.isRouterAlive = false; //先关闭，
        this.$nextTick(function() {
          this.isRouterAlive = true; //再打开
        })
      },
      getBtn() {
        request({
          url: "admin/AdminSysconfig/getConfig",
          method: 'get',
          params:{
            name:'showExportBtn'
          }
        }).then((res)=>{
          if(res.code==200){
            if(res.data == 0){
              this.$store.commit('settings/changeBtn')
            }else{
              this.$store.commit('settings/restoreBtn')
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  // vxe整体样式 ===============================
  /*表头背景色*/
  .vxe-table-style .vxe-header--column {
    // background-color: #1E8AE8;
    background-color: #f7f7f7;
    color: #606266;
    // font-weight: normal;
  }

  /*滚动条整体部分*/
  .vxe-table-scrollbar ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  /*滚动条的轨道*/
  .vxe-table-scrollbar ::-webkit-scrollbar-track {
    background-color: #FFFFFF;
  }

  /*滚动条里面的小方块，能向上向下移动*/
  .vxe-table-scrollbar ::-webkit-scrollbar-thumb {
    background-color: rgba(166, 166, 166, 0.5);
    border-radius: 5px;
    border: 1px solid #F1F1F1;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  }

  .vxe-table-scrollbar ::-webkit-scrollbar-thumb:hover {
    background-color: #A8A8A8;
  }

  .vxe-table-scrollbar ::-webkit-scrollbar-thumb:active {
    background-color: #787878;
  }

  /*边角，即两个滚动条的交汇处*/
  .vxe-table-scrollbar ::-webkit-scrollbar-corner {
    background-color: #FFFFFF;
  }

  .el-button--primary {
    background-color: #006c52;
    border-color: #006c52;
  }

  .el-button--primary:hover,
  .el-button--primary:focus {
    background-color: #006c52;
    border-color: #006c52;
  }

  .el-button--danger {
    background-color: #e31414;
    border-color: #e31414;
  }

  // end vxe =================================
  #app .sidebar-container .is-active>.el-submenu__title {
    background: #DFA64C !important;
  }
</style>
